<template>
	<div class="caseDiv">
		<!-- banner -->
		<div class="banner">
			<!-- <img src="../../assets/img/kjBanner4.jpg" alt=""> -->
			<img src="../../assets/img/kjBanner5.jpg" alt="">
			<div></div>
		</div>
		<!-- 成功案例 -->
		<div class="caseMain">
			<div class="homeTitle">
				<div class="homeTitleText">产品中心</div>
				<div class="homeTitleLine"></div>
			</div>
			<!-- 内容 -->
			<div class="caseMainCon">
				<!-- for循环开始 -->
				<!-- <div> -->
				<div class="caseMainConChild" @click="popShow4" id="caseMainConChildPro4">
					<div class="caseMainConChildImg">
						<img src="../../assets/产品中心/bimboot1.png" alt="">
					</div>
					<div class="caseMainConChildText">
						<h3>BIM协同管理平台</h3>
						<!-- <p>以BIM技术为核心，帮助建筑行业项目，打造成适用多种场景的协同管理平台。
							平台提供一套标准化产品功能模块，也可按照客户需求进行自定义设计开发。目前已有超过20+个项目使用此平台各种功能并取得良好效果。
						</p> -->
					</div>
				</div>
				<div class="caseMainConChild" @click="popShow" id="caseMainConChildPro1">
					<div class="caseMainConChildImg">
						<img src="../../assets/产品中心/sce1.png" alt="">
					</div>
					<div class="caseMainConChildText">
						<h3>国际协同创新区平台</h3>
						<!-- <p>平台包含BIM模型在线预览,多种图表统计分析展示,实时视频监控预览,个性化地图展示项目进度 充分利用各种技术手段满足客户个性化的需求
						</p> -->
					</div>
				</div>
				<!-- </div> -->
				<div class="caseMainConChild" @click="popShow3" id="caseMainConChildPro3">
					<div class="caseMainConChildImg">
						<!-- <img src="../../assets/img/product3.jpg" alt=""> -->
						<img src="../../assets/img/pro-zd.png" alt="">
					</div>
					<div class="caseMainConChildText">
						<h3>物流追溯平台</h3>
						<!-- <p>建筑行业物流追溯平台，以预制构件全过程追溯作为基础，实现全品类物料追溯为最终目标。满足客户在整个建造过程中，对场内外物料的状态精准把控。
							平台利用多种技术手段，包括RFID、二维码标、数据接口等方式，实时追踪物料的整个生命周期信息。并通过各种分析统计方式展现追溯成果。
						</p> -->
					</div>
				</div>
				<div class="caseMainConChild" @click="popShow2" id="caseMainConChildPro2">
					<div class="caseMainConChildImg">
						<!-- <img src="../../assets/img/product2.jpg" alt=""> -->
						<img src="../../assets/img/pro-ctsw.png" alt="">
					</div>
					<div class="caseMainConChildText">
						<h3>一网管协同平台</h3>
						<!-- <p>以BIM协同平台为基础,打造企业级,项目级位一体的协同管理平台。自定义风格的驾驶舱展示,满足客户各种符合其业务场景的功能需求开发。</p> -->
					</div>
				</div>
				<!-- <div class="caseMainConChild" @click="popShow5" id="caseMainConChildPro5">
					<div class="caseMainConChildImg">
						<img src="../../assets/img/pro-jq.png" alt="">
					</div>
					<div class="caseMainConChildText">
						<h3>金桥平台</h3>
						<p>未来城市中心新地标</p>
					</div>
				</div> -->
				<!-- for循环结束 -->
			</div>
			<!-- 分页 -->
			<div class="casePage"></div>
		</div>
		<!-- 引入子组件 -->
		<Popover ref="popover" @refreshtreeTo="refreshtreeTo"></Popover>
		<Popover2 ref="popover2" @refreshtreeTo="refreshtreeTo"></Popover2>
		<Popover3 ref="popover3" @refreshtreeTo="refreshtreeTo"></Popover3>
		<Popover4 ref="popover4" @refreshtreeTo="refreshtreeTo"></Popover4>
		<Popover5 ref="popover5" @refreshtreeTo="refreshtreeTo"></Popover5>
	</div>
</template>
<script>
	import Popover from '../../components/Popover.vue';
	import Popover2 from '../../components/Popover2.vue';
	import Popover3 from '../../components/Popover3.vue';
	import Popover4 from '../../components/Popover4.vue';
	import Popover5 from '../../components/Popover5.vue';
	export default {
		components: {
			Popover,
			Popover2,
			Popover3,
			Popover4,
			Popover5,
		},
		data() {
			return {};
		},
		mounted() {
			// console.log(this.$route.query.pointIdName, "this.$route.query11")
			let pointIdName = this.$route.query.pointIdName
			if (pointIdName != undefined) {
				this.goRule(pointIdName)
			}
		},
		created() {
			document.documentElement.scrollTop = 0;
		},
		methods: {
			//锚点跳转
			goRule(event) {
				let id = "#" + event;
				console.log(document.querySelector(id), "document.querySelector(id)")
				document.querySelector(id).scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "nearest",
				}, true);
				let that = this
				if (event == 'caseMainConChildPro1') {
					this.$nextTick(() => {
						that.$refs.popover.show()
					})
				} else if (event == 'caseMainConChildPro2') {
					this.$nextTick(() => {
						that.$refs.popover2.show()
					})
				} else if (event == 'caseMainConChildPro3') {
					this.$nextTick(() => {
						that.$refs.popover3.show()
					})
				} else if (event == 'caseMainConChildPro4') {
					this.$nextTick(() => {
						that.$refs.popover4.show()
					})
				}
				//  else if (event == 'caseMainConChildPro5') {
				// 	this.$nextTick(() => {
				// 		that.$refs.popover5.show()
				// 	})
				// }
				// setTimeout(() => {
				// 	that.$refs.popover.show()
				// }, 500);
			},
			// 显示弹窗
			popShow() {
				this.$refs.popover.show()
			},
			popShow2() {
				this.$refs.popover2.show()
			},
			popShow3() {
				this.$refs.popover3.show()
			},
			popShow4() {
				this.$refs.popover4.show()
			},
			// popShow5() {
			// 	this.$refs.popover5.show()
			// },
			refreshtreeTo() { }
		},
	}
</script>
<style lang="scss" scoped>
	.caseDiv,
	.banner {
		width: 100%;
	}

	.caseDiv {
		background: #f7f8fa;
	}

	.banner {
		height: 450px;
		margin-bottom: 45px;
		position: relative;

		div {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(33, 37, 44, .2);
		}

		img {
			width: 100%;
			height: 100%;
		}
	}

	// 标题开始
	.homeTitle {
		width: 100%;
		text-align: center;
		margin: 0 auto;
		margin-bottom: 35px;

		.homeTitleText {
			height: 45px;
			font-size: 31px;
			color: #000;
			font-weight: 500;
			// padding: 60px 0 8px 0;
			padding: 30px 0 8px 0;
		}

		.homeTitleLine {
			width: 64px;
			height: 3px;
			background: #006fff;
			margin: 0 auto;
		}
	}

	// caseMain开始****************
	.caseMain {
		width: 65%;
		margin: 30px auto 0;
		// margin: 0 auto;

		.caseMainCon {
			width: 100%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			margin: 30px 20px;

			.caseMainConChild {
				width: 40%;
				margin: 0 0.916% 30px;
				background: #fff;
				border-radius: 10px;
				overflow: hidden;
				margin-left: 60px;

				.caseMainConChildImg {
					height: 220px;
					overflow: hidden;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.caseMainConChildText {
					text-align: center;
					border: 1px #e2e2e2 solid;
					border-top: none;


					h3 {
						font-size: 16px;
						color: #333;
						font-weight: normal;
						padding: 15px 10px;
						display: block;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					p {
						font-size: 12px;
						padding-bottom: 12px;
					}
				}
			}

		}
	}

	.caseMainConChild:hover {
		cursor: pointer;
		// box-shadow: 0 0 30px rgba(33, 37, 44, .5);
		box-shadow: 10px 10px 10px -4px rgba(0, 0, 0, .25);
	}

	// caseMain结束****************


	// casePage开始****************
	.casePage {
		width: 100%;
		text-align: center;
		height: 20px;
		// background: red;
		// padding: 20px 0;
		padding: 8px 0;
		background: #f7f8fa;
	}

	// casePage结束****************


	// ****************修改样式
	.caseDiv /deep/ .el-carousel__container {
		height: 350px;
	}
</style>